

angular
.module('inkfinder')
.factory('ScheduleApiFormat', function ScheduleApiFormat(
  Session,
  moment,
  _
) {
  // Public methods
  ScheduleApiFormat.format = format;

  /**
   * @name format
   * @description Pre-process the Sending of an Exception to the API
   * @param {unknown} form unknown
   * @param {unknown} artist unknown
   * @return {unknown} Unknown
   */
  function format(form, artist) {
    let processed = {};
    // Editing
    if (form.id) {
      // Default Options
      processed.artist_id = artist.id;
      processed.artist_hour_id = form.id;

      processed.start_date =
      moment(form.temp.raw_start_date).format('YYYY-MM-DD');
      if (form.temp.raw_end_date) {
        processed.end_date =
        moment(form.temp.raw_end_date).format('YYYY-MM-DD');
      }
      processed.selected_days = form.selected_days;
      processed.interval = parseInt(form.weekly_frequency, 10);

      processed.end_time =
      moment(form.temp.raw_end_time).format('HH:mm:ss');
      processed.start_time =
      moment(form.temp.raw_start_time).format('HH:mm:ss');
      processed.deleted = false;
    } else {
      // Create New
      // Default Options
      processed.artist_id = artist.id;

      processed.start_date =
      moment(form.temp.raw_start_date).format('YYYY-MM-DD');
      if (form.temp.raw_end_date) {
        processed.end_date =
        moment(form.temp.raw_end_date).format('YYYY-MM-DD');
      }
      processed.selected_days = form.selected_days;
      processed.interval = parseInt(form.weekly_frequency, 10);

      processed.end_time =
      moment(form.temp.raw_end_time).format('HH:mm:ss');
      processed.start_time =
      moment(form.temp.raw_start_time).format('HH:mm:ss');
      processed.deleted = false;
    }
    return processed;
  }
  return ScheduleApiFormat;
});



// WEBPACK FOOTER //
// ./components/schedule/util/api-format-schedule.service.js